/*
 *
 * Copyright 2021, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */
import './WrcFormAggregate.css';
import React from 'react';
import { Card, Elevation } from "@blueprintjs/core";
import { Tab, Tabs } from "@blueprintjs/core";
import WrcDetailContent from "./WrcDetailContent.js";

export class WrcFormAggregate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded: false
        };
        this.handleTabChange = this.handleTabChange.bind(this)
    }

    componentDidMount() {
        let parentState = this.props.parentGetState()
        if (parentState['aggregate_tab'] !== undefined) {
            this.handleTabChange(parentState['aggregate_tab'], 'mount');
        } else {
            this.handleTabChange('tab1', 'mount');
        }
    }

    componentWillUnmount() {
        this.props.parentSetState({
            aggregate_tab: this.state.aggregate_tab
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.record_id !== this.props.record_id ||
            prevProps.references !== this.props.references ||
            prevProps.fkey !== this.props.fkey) {
            if (this.props.level === 'child') {
                this.setState({
                    selected_grandchild: undefined,
                    grandchild_list_data: undefined,
                    current_grandchild_tab: 'tab1',
                    aggregate_tab: 'tab1'
                });
            } else if (this.props.level === 'grandchild') {
                this.setState({
                    aggregate_tab: 'tab1'
                });
            }
        }
    }

    unpack = (elem_condensed) => {
        let elem_expanded;
        if (Array.isArray(elem_condensed)) {
            elem_expanded = [];
            for (let i = 0; i < elem_condensed.length; i++) {
                if (elem_condensed[i].table_name !== undefined) {
                    elem_expanded.push(elem_condensed[i]);
                }
                if (Array.isArray(elem_condensed[i].subtabs)) {
                    for (let j = 0; j < elem_condensed[i].subtabs.length; j++) {
                        if (elem_condensed[i].subtabs[j].table_name !== undefined) {
                            elem_expanded.push(elem_condensed[i].subtabs[j]);
                        }
                    }
                }
            }
        }
        return elem_expanded;
    };

    handleTabChange = (tabId, source) => {
        this.setState({
            aggregate_tab: tabId,
            is_loaded: true
        });
        // only want to reset grandchild details if the tab change is at the child level
        if (this.props.level === 'child' && source !== 'mount') {
            this.props.grandChildCallback({
                selected_grandchild: undefined,
                grandchild_list_data: undefined,
                current_grandchild_tab: 'tab1'
            })
        }

    };

    render() {
        let height = `${this.props.height}px`;
        let agg_full_class = this.props.agg_text_align === 'left' ? 'agg_tab_labels_left' : 'agg_tab_labels_center';
        let vertical_tabs = this.props.agg_tab_direction === 'horizontal' ? false : true;
        let tabs = [];
        if (this.state.is_loaded) {
            if (Array.isArray(this.props.subtabs)) {
                tabs = this.props.subtabs.map(function (subtab, index) {
                    return (
                        <Tab title={subtab.title} className={agg_full_class} panelClassName='tab-panel' id={'tab' + (index + 1)} panel={
                            <WrcDetailContent
                                program_role={this.props.program_role}
                                readonly_if={this.props.readonly_if}
                                
                                height={this.props.height}
                                descendants={subtab.children}
                                component_index={this.props.component_index}
                                refresh={this.props.refresh}
                                table_schema={this.props.table_schema}
                                table_name={subtab.table_name}
                                references={this.props.references}
                                selected_element={subtab}
                                elements={this.props.subtabs}
                                display_type={subtab.display}
                                page_length={this.props.page_length}
                                class_name={this.props.class_name}
                                index={index}
                                subtraction={1}
                                level={this.props.level}
                                fkey={this.props.fkey}
                                index={this.props.index}
                                use_aggregate_tab={true}
                                aggregate_tab={this.state.aggregate_tab}
                                selectGrandChild={this.props.selectGrandChild}
                                selected_grandchild={this.props.selected_grandchild}
                                grandChildCallback={this.props.grandChildCallback}
                                readonly={this.props.readonly}
                                parentCallback={this.props.parentCallback}
                                selected_item={this.props.selected_item}
                                parentSetState={this.props.parentSetState}
                                parentGetState={this.props.parentGetState}
                                list_data={this.props.list_data}
                                child_list_data={this.props.child_list_data}
                                grandchild_list_data={this.props.grandchild_list_data}
                                current_tab={this.state.aggregate_tab}
                                current_grandchild_tab={this.props.current_grandchild_tab}
                                record_id={this.props.record_id}
                            />
                        } />
                    );
                }.bind(this));
            }
        }

        return ((this.state.is_loaded) ?
            (<Card interactive={false} elevation={Elevation.TWO} style={{ minHeight: height, overflowY: 'auto' }}>
                <Tabs
                    large={false}
                    renderActiveTabPanelOnly={true}
                    onChange={(tab) => this.handleTabChange(tab, 'tabs')}
                    selectedTabId={this.state.aggregate_tab}
                    vertical={vertical_tabs}
                >
                    {tabs}
                </Tabs>
            </Card>) :
            (<div>
                <Card style={{ height: height }}><h3>Loading...</h3></Card>
            </div>)
        );
    };
}

export default WrcFormAggregate;
